export default function getFieldsFromForm(form: Form | null): FormField[] {
    const { fields } = form || {};
    return fields.reduce((acc, field) => {
        const { type } = field || {};
        if (type === 'group') {
            const { fields: groupFields } = field;
            return groupFields.reduce((groupAcc, groupField) => [...groupAcc, groupField], acc);
        }
        return [...acc, field];
    }, []);
}
